import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Project } from '@apps/projects/projects.state';
import { sliceArray } from '@platform/shared/utilities/obserables-utils';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-project-widget-table',
  templateUrl: './project-widget-table.component.html',
  styleUrls: ['./project-widget-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectWidgetTableComponent {
  @Input() customerSpaceId: string;
  @Input() projects$: Observable<ReadonlyArray<Project>>;
  @Input() displayRowsCount = 6;
  @Input() isInternalUser: boolean;
  @Output() numberClicked = new EventEmitter<number>();

  displayedColumns = ['name', 'numbers', 'managers', 'actions'];

  get projectsSliced$() {
    return this.projects$.pipe(sliceArray(this.displayRowsCount));
  }
}
